/* admin */
import { RouteLogin } from './Admin/RouteLogin.js';
import { RouteCollection } from './Admin/RouteCollection.js';
import { RouteInsert } from './Admin/RouteInsert.js';
import { RouteUpdate } from './Admin/RouteUpdate.js';
/* test */
import { TestRoutesEntities } from './Testing/TestRoutesEntities.js';
import { TestRoutesNoSQL } from './Testing/TestRoutesNoSQL.js';

export const RouterAdmin = () => {
    const uri = window.location.href;
    if (!uri.match(/admin/)) return (<></>);
    if (uri.includes('/admin/login')) return (<RouteLogin />);
    if (uri.includes('/admin/test/routes/entities')) return (<TestRoutesEntities />);
    if (uri.includes('/admin/test/routes/nosql')) return (<TestRoutesNoSQL />);
    if (uri.includes('/admin/entity/collection')) return (<RouteCollection />);
    if (uri.includes('/admin/entity/insert')) return (<RouteInsert />);
    if (uri.includes('/admin/entity/update')) return (<RouteUpdate />);
}